import { isMobile, isTablet } from "react-device-detect";
import { ProductReelType } from "./types";

export const productReelConstants = {
  productCardWidth: 240,
  productCardHeight: 430,
  cellsOffset: isMobile ? 1 : isTablet ? 2 : 4,
  productPaddingAndMargin: 40,
  cellsNumber: 4,
  cellsNumberMobile: 1,
  cellsNumberTablet: 2,
};

export const productReelTypeToText: { [key: string]: string } = {
  [ProductReelType.Newest]: "Най-нови",
  [ProductReelType.BestSeller]: "Най-продавани",
  [ProductReelType.Advantageous]: "Най-изгодни",
};
